<article class="page-container">
  <!-- page title -->
  <h1 mat-dialog-title class="h1 h1--component-title">
    {{ 'apply.label.title' | translate | async }}
  </h1>
  <div mat-dialog-content class="content">
    <p>
      {{ 'apply.label.content.p1' | translate | async }}
    </p>
    <p>
      {{ 'filter.menu.content.p2' | translate | async }}
    </p>
    <fieldset>
      <legend>
        {{ 'apply.label.legend' | translate | async }}
      </legend><br />
      @if (labelList$()) {
        <section class="example-section" [formGroup]="labelList$()">
          @if (canSeeLabels) {
            @for (key of object.keys(labelList$().controls); track key; let i = $index) {
              <p>
                <mat-checkbox attr.aria-label="{{ labelName(key) }}"
                  (change)="toggleLabel($event, key)" [formControlName]="key">{{labelName(key)}}
                </mat-checkbox>
              </p>
            }
          } @else {
            <p>
              {{ 'apply.label.no.label' | translate | async }}
            </p>
          }
        </section>
      }
    </fieldset>
  </div>
  <!-- border line -->
  <hr class="border-line">
  <!-- action toolbar -->
  <div class="footer">
    <div class="flex-child">
      <!-- manage labels button -->
      <button type="button" class="button button--green-secondary" mat-stroked-button
        (click)="openManageLabelsDialog()">
        {{ 'dialog.action.manage.labels' | translate | async }}
      </button>
      <!-- close button -->
      <button type="button" class="button button--black-primary" mat-stroked-button (click)="close()">
        {{ 'dialog.action.close' | translate | async }}
      </button>
    </div>
  </div>
</article>